<template>
  <section id="dashboard">
    <div v-if="userData.roles[0].id == 1">
      <superAdmin :isLoading="isLoading" :userData="userData" :dataDashboard="dataDashboard" @buscar="buscar($event)" />
    </div>
    <div v-if="userData.roles[0].id == 2">
      <admin :isLoading='isLoading' :userData="userData" :dataDashboard="dataDashboard" @buscar="buscar($event)" />
    </div>
  </section>
</template>

<script>
import axios from "@/core/services/api/dashboard";
import superAdmin from "./superAdmin/superAdmin.vue";
import admin from "./admin/admin.vue";

export default {
  components: {
    admin,
    superAdmin,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      dataDashboard: {},
      isLoading: false,
    };
  },
  created() {
    if (this.userData.roles[0].id != 2) this.buscar({ start: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-1`, end: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}` });
  },
  methods: {
    buscar({ start, end, facilities }) {
      this.isLoading = true;
      const datarda = {
        start_date: start,
        end_date: end,
        facilities
      };
      if (this.userData.roles[0].id != 1 && this.userData.roles[0].id != 2) datarda.user_id = this.userData.id
      axios.getAllDashboardData(datarda).then((data) => {
        this.dataDashboard = {
          ...data.allDataCount.data,
          ...data.all_patients.data,
          ...data.all_patients_by_insurance.data,
          ...data.bonus.data,
          ...data.total_refunds.data,
          ...data.values_totals,
          ...data.year_data.data,
        };
        this.isLoading = false;
      }).catch((error) => {
        console.error('Error loading dashboard data:', error);
        this.isLoading = false;
        // Show error message to user
        this.$bvToast.toast('Error loading data. Please try again.', {
          title: 'Data Loading Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        });
      });
    },
  },
};
</script>
